"use client";

import { usePathname } from "next/navigation";
import { EnrollmentGate } from "./enrollment-gate";

// 학생 프로그램 라우트에만 등록(EnrollmentGate)을 적용한다.
// 랜딩/로그인(/career-launch), 운영 콘솔(/career-launch/ops·ops-report), 리다이렉트(/apply)는 제외 —
// 랜딩을 게이트로 감싸면 미로그인 방문자가 로그인 대신 초대코드 화면을 보게 되기 때문.
// 운영자는 API에서 항상 enrolled=true 로 처리되어 그대로 통과한다.
const GATED_PREFIXES = [
  "/career-launch/program",
  "/career-launch/week",
  "/career-launch/diagnosis",
  "/career-launch/experience",
  "/career-launch/profile",
  "/career-launch/jobs",
  "/career-launch/materials",
  "/career-launch/story",
  "/career-launch/company",
  "/career-launch/resume-collect",
  "/career-launch/resume-preview",
  "/career-launch/cover-collect",
  "/career-launch/cover-preview",
  "/career-launch/interview",
  "/career-launch/basic-interview",
  "/career-launch/corrections",
  "/career-launch/intro-practice",
  "/career-launch/deliverables",
  "/career-launch/survey",
  "/career-launch/culture"
];

// 운영 콘솔(/career-launch/ops·ops-report·ops-print)은 자체 디자인 시스템 — v2 껍데기(.v2)를 씌우지 않는다.
const OPS_PREFIX = "/career-launch/ops";

export function ProgramGate({ children }: { children: React.ReactNode }) {
  const pathname = usePathname() ?? "";
  const gated = GATED_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
  if (pathname.startsWith(OPS_PREFIX)) return <>{children}</>;
  // 학생 화면 — v2 색(--v2-*)이 풀리도록 .v2 로 감싼다.
  return <div className="v2">{gated ? <EnrollmentGate>{children}</EnrollmentGate> : children}</div>;
}
